module.exports = __webpack_public_path__ + "static/media/language_image_mini.7428c1b4.jpg";